/*
Copyright (C) 2017  Cloudbase Solutions SRL
This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import React from "react";
import { createRoot } from "react-dom/client";

import App from "./components/App";
import { startSessionGuard } from "./utils/SessionGuard";

// Back/Forward, activity and the idle limit (utils/SessionGuard.ts), before anything is shown.
startSessionGuard();

const container = document.getElementById("app");

const root = createRoot(container!);
root.render(<App />);
